'use strict';

import baseConfig from './base';

let config = {
  facebookOauth: 'https://www.facebook.com/v2.11/dialog/oauth?client_id=548037332212720&response_type=token&redirect_uri=https://prescriptionrevision.com/facebookauthcallback&scope=email'
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./src/config/dist.js